import React, { forwardRef, type ReactNode } from "react";
import type { BaseProps } from "@purpur/common-types";
import c from "classnames/bind";

import styles from "./card-root.module.scss";

const cx = c.bind(styles);

export type CardRootProps = Omit<BaseProps, "children"> & {
  children: ReactNode;
  fullHeight?: boolean;
  /** Use the prop useMediaQueries when the cards are used beside each other in different sized grid items for example. */
  useMediaQueries?: boolean;
  variant?: "primary" | "secondary";
};

const rootClassName = "purpur-card-root";

export const CardRoot = forwardRef<HTMLDivElement, CardRootProps>(
  (
    {
      ["data-testid"]: dataTestId = "purpur-card-root",
      children,
      className,
      fullHeight = true,
      variant,
      ...props
    },
    ref
  ) => {
    const classes = cx([
      rootClassName,
      {
        [`${rootClassName}--${variant}`]: variant,
        [`${rootClassName}--full-height`]: fullHeight,
      },
      className,
    ]);

    return (
      <div className={classes} data-testid={dataTestId} ref={ref} {...props}>
        {children}
      </div>
    );
  }
);

CardRoot.displayName = "CardRoot";
